module.exports = __webpack_public_path__ + "static/fonts/notokr-medium.81bd542.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/relayevent/font/notokr-medium.woff
// module id = yoq+
// module chunks = 0